import { Flex, ChakraBaseProvider } from "@chakra-ui/react";

import '../styles/layout.scss';
import claverTheme from './theme/claverTheme';


export default function PublicPageLayout(props) {
	return (
		<ChakraBaseProvider theme={claverTheme}>
			<Flex direction='column' minHeight='100vh' className='access-page-background'>
				{props.children}
			</Flex>
		</ChakraBaseProvider>
	);
}